import { apiRequest, buildURL } from './commons/CommonService.Functions';
import { SpecialtyCreateCommand, SpecialtyUpdateCommand, SpecialtyViewModel } from '../models/Entities/Specialties/SpecialtyModels';

// Base url for specialties
const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'medical-specialties';

// Get all specialties
export const GetAllSpecialties = async (token: string): Promise<SpecialtyViewModel[]> => {
    return apiRequest<SpecialtyViewModel[]>(BaseURL, token, 'GetAllSpecialties');
};

// Get specialty by id
export const GetSpecialtyById = async (token: string, specialtyId: number): Promise<SpecialtyViewModel> => {
    const requestUrl: string = buildURL(BaseURL, specialtyId);
    return apiRequest<SpecialtyViewModel>(requestUrl, token, 'GetSpecialtyById');
};

// Create specialty now returns created Specialty
export const CreateSpecialty = async (token: string, payload: SpecialtyCreateCommand): Promise<SpecialtyViewModel> => {
    return apiRequest<SpecialtyViewModel>(BaseURL, token, 'CreateSpecialty', {
        method: 'POST',
        body: JSON.stringify(payload)
    });
};

// Update specialty now returns updated Specialty
export const UpdateSpecialty = async (token: string, payload: SpecialtyUpdateCommand): Promise<SpecialtyViewModel> => {
    return apiRequest<SpecialtyViewModel>(BaseURL, token, 'UpdateSpecialty', {
        method: 'PUT',
        body: JSON.stringify(payload)
    });
};

// Delete specialty
export const DeleteSpecialty = async (token: string, specialtyId: number): Promise<number> => {
    const requestUrl: string = buildURL(BaseURL, specialtyId);
    return apiRequest<number>(requestUrl, token, 'DeleteSpecialty', {
        method: 'DELETE'
    });
};
